import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subject, Subscription } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { InfoAnagrafichePFDTO } from '../../models/info-anagrafiche-pf';
import { PersonaFisicaBaseDTO } from '../../models/persona-fisica-base-dto';
import { DatiPersonaFisica } from '../../models/portale/dati-persona-fisica';
import { PersonaFisica } from '../../models/portale/persona-fisica-model';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';
import { DelegheService } from '../../services/deleghe-services/deleghe.service';

@Component({
	selector: 'lib-ricerca-pf',
	templateUrl: './ricerca-pf.component.html',
	styleUrls: ['./ricerca-pf.component.css']
})
export class RicercaPfComponent implements OnInit {

	@Input()
	namespace: string;

	@Input()
	readOnly: boolean;

	@Output()
	done: EventEmitter<
		ComponentOutputStatus<DatiPersonaFisica>
	> = new EventEmitter<ComponentOutputStatus<DatiPersonaFisica>>();

	resetForm = new Subject<boolean>();

	personaFisica$: Observable<PersonaFisica>;
	pfSubscription: Subscription;

	codiceFiscale: string = "";
	cognome: string = "";
	nome: string = "";

	dataSource: MatTableDataSource<any>;
	listaPf;
	offset: number = 0;
	pageNumber: number = 0;
	pageSize: number = 5;
	paged: boolean = true;
	showNoResults: boolean;
	viewIntPf: boolean = false;
	viewResultTable: boolean = false;
	resLenPf = 0;
	validationFormPF: boolean = false;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	pageEvent: PageEvent;

	displayedColumns: string[] = [
		'codiceFiscale',
		'nome',
		'cognome',
		'seleziona'
	];

	constructor(
		private delegheService: DelegheService,
	) { }

	ngOnInit(): void {
	}

	infoPfReady(inFoPfStatus: ComponentOutputStatus<InfoAnagrafichePFDTO>) {
		// console.log('[infoPfReady]', inFoPfStatus);
		this.validationFormPF = inFoPfStatus.status;

		if (inFoPfStatus.output.codFiscale != undefined) {
			this.codiceFiscale = inFoPfStatus?.output.codFiscale.toUpperCase().trim();
		}
		if (inFoPfStatus.output.cognome != undefined) {
			this.cognome = inFoPfStatus?.output.cognome.toUpperCase().trim();
		}
		if (inFoPfStatus.output.nome != undefined) {
			this.nome = inFoPfStatus?.output.nome.toUpperCase().trim();
		}
	}

	getListaPf() {
		this.listaPf = '';
		this.dataSource = new MatTableDataSource(this.listaPf);

		const pf = new PersonaFisicaBaseDTO();
		pf.codiceFiscale = this.codiceFiscale;
		pf.cognome = this.cognome;
		pf.nome = this.nome;

		// this.delegheService.getListaPfPaged(this.pageSize, this.pageNumber, pf);

		if (pf.codiceFiscale != "" && pf.cognome == "" && pf.nome == "") {
			console.log("[Ricerca Anagrafe Tributaria]");
			this.delegheService.getPersonaFiscaleCodiceFiscale(pf.codiceFiscale).pipe(
				// pluck("datiPersonaFisica")
			)
				.subscribe(
					(res: PersonaFisica) => {
						console.log('[pg]', res);
						this.listaPf = res;
						console.log('[listaPf]', this.listaPf);
						if (this.listaPf) {
							this.showNoResults = false;
							this.viewIntPf = true;
							this.viewResultTable = true;
							// this.dataSource = new MatTableDataSource(this.listaPg['content']);
							this.dataSource = new MatTableDataSource([this.listaPf]);
							// this.dataSource = new MatTableDataSource([res]);
							// this.dataSource.paginator = this.paginator;
							// this.resLenPg = res['content'].length;
							this.resLenPf = 1;
						} else {
							this.showNoResults = true;
							this.viewIntPf = false;
							this.viewResultTable = false;
							this.resLenPf = 0;
						}
					},
					err => {
						// console.log('[errore - getListaPfPaged]', err);
						this.showNoResults = true;
						this.viewIntPf = false;
						this.viewResultTable = false;
						this.resLenPf = 0;
					}
				)
		}
		else {
			console.log("[Ricerca Sul Portale]");

			this.personaFisica$ = this.delegheService.getListaPfPaged(this.pageSize, this.pageNumber, pf)
				.pipe(shareReplay());

			this.pfSubscription = this.personaFisica$.pipe(
				// pluck("datiPersonaFisica")
			).subscribe(
				(res: PersonaFisica) => {
					console.log('[pf]', res);
					this.listaPf = res;
					if (this.listaPf) {
						this.showNoResults = false;
						this.viewIntPf = true;
						this.viewResultTable = true;
						this.dataSource = new MatTableDataSource(this.listaPf['content']);
						this.dataSource.paginator = this.paginator;
						this.resLenPf = res['content'].length;
					} else {
						this.viewIntPf = false;
						this.viewResultTable = false;
						this.showNoResults = true;
						this.resLenPf = 0;
					}
				},
				err => {
					// console.log('[errore - getListaPfPaged]', err);
					this.viewIntPf = false;
					this.viewResultTable = false;
					this.showNoResults = true;
					this.resLenPf = 0;
				}
			)
		}
	}

	pulisciForm() {
		this.resetForm.next(true);
		this.viewResultTable = false;
		this.dataSource = new MatTableDataSource(null);
		this.viewIntPf = false;
		// console.log('[pulisciForm - resetForm]', this.resetForm);
	}

	areSearchParameterValid(): boolean {
		return (
			this.validationFormPF &&
			(this.codiceFiscale != "" ||
				this.cognome != "" ||
				this.nome != "")
		);
	}

	personaFisicaSelected(row: PersonaFisica) {
		// console.log('[PersonaFisica]', row);
		this.done.emit(ComponentOutputStatus.of(true, row.datiPersonaFisica));
	}
}